import { Injectable } from '@angular/core';
import { FlowTypes, urlMapper } from '@interfaces/models';
import { select, Store } from '@ngrx/store';
import { Go } from '@store/actions';
import * as fromRootStore from '@store/index';
import { selectDecedentInfoState } from '@store/selectors/decedent-info/decedent-info.selectors';
import { flowTypeSelection } from '@store/selectors/triage/triage.selectors';
import { CookieService } from 'ngx-cookie-service';
import { combineLatest, map, Observable, of, take } from 'rxjs';

@Injectable()
export class DecedentInfoGuard {
  constructor(
    private globalStore: Store<fromRootStore.State>,
    private cookieService: CookieService,
  ) {}

  canActivate(): Observable<boolean> {
    if (this.cookieService.get('routeGuard') === 'OFF') {
      return of(true);
    }

    return combineLatest([
      this.globalStore.pipe(select(flowTypeSelection)),
      this.globalStore.pipe(select(selectDecedentInfoState)),
    ]).pipe(
      take(1),
      map(([flowType, decedentInfo]) => {
        // Only enforce for inheritance flows; allow others to proceed normally
        if (flowType === FlowTypes.INHERITANCE || flowType === FlowTypes.MULTI_INHERITANCE) {
          const hasVerificationDecision = !!decedentInfo.deathStatusSetBy;
          const exceededAttempts = !!decedentInfo.decedentIdExceededAttempts;
          if (!hasVerificationDecision && !exceededAttempts) {
            this.globalStore.dispatch(
              Go({ path: [`secure/${urlMapper[flowType]}/decedent-info`] }),
            );
            return false;
          }
        }
        return true;
      }),
    );
  }
}
